import React, { useRef, MutableRefObject } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';

type InputProps = {
  id: string;
  name: string;
  value: string;
  onChange: (params: {
    name: string;
    value: string;
    node: MutableRefObject<FormControl | null>;
  }) => void;
  type?: string;
  label?: string;
  placeholder?: string;
  errorText?: string;
  onKeyUpEnter?: React.KeyboardEventHandler<FormControl>;
  className?: string;
  onFocus?: React.FocusEventHandler<FormControl>;
  onBlur?: React.FocusEventHandler<FormControl>;
  autoFocus?: boolean;
};

const Input = ({
  className,
  id,
  name,
  value,
  onChange,
  type = 'text',
  label,
  placeholder,
  errorText,
  onKeyUpEnter,
  onBlur,
  onFocus,
  autoFocus = false,
}: InputProps) => {
  const inputRef = useRef<FormControl | null>(null);

  const handleKeyUp = (event: React.KeyboardEvent<FormControl>) => {
    const { keyCode } = event;

    if (keyCode === 13 && onKeyUpEnter) onKeyUpEnter(event);
  };

  // @see https://github.com/react-bootstrap/react-bootstrap/issues/2781#issuecomment-356463606
  const handleChange = (event: React.FormEvent<FormControl & HTMLInputElement>) => {
    const {
      currentTarget: { value: targetValue },
    } = event;

    onChange({
      name,
      value: targetValue,
      node: inputRef,
    });
  };

  return (
    <FormGroup className={className} controlId={id} validationState={errorText ? 'error' : null}>
      {label && <ControlLabel>{label}</ControlLabel>}
      <FormControl
        ref={inputRef}
        type={type}
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyUp={handleKeyUp}
        autoFocus={autoFocus}
      />
      {errorText && <span className="help-block">{errorText}</span>}
    </FormGroup>
  );
};

export default Input;
